/**
 * @generated SignedSource<<b2943c96b5777cee2612fc5a779fdccd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnalyticsDatumText_analyticsDatum",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconClass",
      "storageKey": null
    }
  ],
  "type": "AnalyticsDatumInterface",
  "abstractKey": "__isAnalyticsDatumInterface"
};

node.hash = "a16867a5045062d11d6ef3a10cb22635";

module.exports = node;
